import jss from 'jss'
import preset from 'jss-preset-default'
// (function ($) {
//     var icon_masthead = $('#ecf-masthead-gen box-img-masthead source')
//     setPosition()
//     function setPosition(){
//         var top = icon_masthead.data('top');
//         var left = icon_masthead.data('left');

//         console.log(icon_masthead.data('top'));
//         $('.box-img-masthead img').css({"top":top , 'left': left});
//     }
// })(jQuery);
// import $ from "jquery";

class WidgetPosition extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        img: ".box-img-masthead img",
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $img: this.$element.find(selectors.img),
    };
  }
  
  getPosition(img){
    let obj = JSON.parse(img.getAttribute('att-position'))
    let {top_desktop,left_desktop,bottom_desktop,right_desktop,top_mobile,left_mobile,bottom_mobile,right_mobile} = obj;
    jss.setup(preset())
    const styles = {
        img:{
            position: 'absolute',
            top: top_desktop,
            left: left_desktop,
            bottom: bottom_desktop,
            right: right_desktop,
        },
        '@media (max-width: 768px)': {
            img:{
                top: top_mobile == '' ? 'unset' : top_mobile ,
                left: left_mobile == '' ? 'unset' : left_mobile,
                bottom: bottom_mobile == '' ? 'unset' : bottom_mobile,
                right: right_mobile == '' ? 'unset' : right_mobile,
            },
        }
    }

    const {classes} = jss.createStyleSheet(styles).attach()
    img.classList.add(classes.img)
  }

  bindEvents() {
    var $this = this;
    let img = this.elements.$img;
    img.each(function(index, element){
        $this.getPosition(element)
    });
  }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetPosition, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_cta_box.default",
    addHandler
  );
});
